import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import { Helmet } from "react-helmet-async";
import CashFlowProfitFilter from "./CashFlowProfitFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import CashFlowProfitList from "./CashFlowProfitList";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { firstDayOfMonth, lastDayOfMonth } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

import { StyledCashFlowProfitWrapper } from "./styledCashFlowProfit";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const CashFlowProfitContainer = () => {
  const { t } = useTranslation("cashFlow");
  const [profits, setProfits] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "profits", false, true),
    "currency": checkFilterItem(history, "currency", null),
    "paymentSystem": checkFilterItem(history, "paymentSystem", null),
    "service": checkFilterItem(history, "service", null),
    "dateFrom": checkFilterItem(history, "dateFrom", firstDayOfMonth()),
    "dateTo": checkFilterItem(history, "dateTo", lastDayOfMonth())
  });

  const fetchProfit = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/get-profit" + filterUrl + "&byClient=0", userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {

        setProfits(response.data["profits"]);
        setTotalPageCount(response.data["totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchProfit();
  }, [filterData]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledCashFlowProfitWrapper>
        <Helmet>
          <title>{t("profit.meta.title")}</title>
        </Helmet>
        <div className="content-head">
          <CashFlowProfitFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <CashFlowProfitList profits={profits} filterData={filterData} />
        {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledCashFlowProfitWrapper>
    </>
  );
};

export default CashFlowProfitContainer;